{
    "@metadata": {
		"authors": [
			"Jon Robson",
			"Jon Harald Søby",
			"Amire80"
		]
	},
    "share-to-clipboard": "Share image to clipboard",
    "project-wikipedia": "Wikipedia",
	"project-commons": "Commons",
	"project-wikisource": "Wikisource",
	"project-wiktionary": "Wiktionary",
	"project-wikifunctions": "Wikifunctions",
	"project-wikidata": "Wikidata",
	"project-wikivoyage": "Wikivoyage",
	"project-wikinews": "Wikinews",
	"project-wikiversity": "Wikiversity",
	"project-wikibooks": "Wikibooks",
	"project-wikiquote": "Wikiquote",
	"project-mediawiki": "MediaWiki",
	"project-wikimedia": "Wikimedia",
    "intro": "Let's look back at all the good work you have been doing this year in helping build the best place on the Internet!",
    "text-shared": "Text has been shared to your clipboard.",
    "image-shared": "An image has been shared to your clipboard.",
    "language-ar": "Arabic",
    "language-nl": "Dutch",
    "language-fr": "French",
    "language-az": "Azerbaijani",
    "language-pa": "Punjabi",
    "language-fi": "Finnish",
    "language-tr": "Turkish",
    "language-bn": "Bangla",
    "language-skr-arab": "Saraiki (Arabic script)",
    "language-sr-ec": "Serbian (Cyrillic script)",
    "language-it": "Italian",
    "language-ru": "Russian",
    "language-es": "Spanish",
    "language-lb": "Luxembourgish",
    "language-mk": "Macedonian",
    "language-ur": "Urdu",
    "year-in-review": "Year in Review",
    "username-placeholder": "What's your username?",
    "project-label": "Your Wikimedia project:",
    "get-started": "Get started",
    "error-share": "An unexpected error occurred during the share process.",
    "error-clipboard": "An unexpected error occurred while attempting to copy to the clipboard.",
    "error-toomanyedits": "This username has too many edits. Unfortunately it is not supported at the current time.",
    "error-generic": "An error occurred while trying to check that: $1.",
    "year-placeholder": "Select year",
    "save-image": "Download as image",
    "thanks-for-playing": "Thank you for viewing your year in review and for contributing to the sum of all human knowledge.",
    "thanks": "thanks",
    "hny": "Happy $1!",
    "share": "Share stats",
    "language-en": "English",
    "language-yoda": "Yoda",
    "language-label": "Change language",
    "you-made-contributions-to": "You made contributions to",
    "and": "and",
    "edits-you-made": "You made <strong>$1</strong><span>edits</span> across the project.",
    "files-you-uploaded": "You uploaded <strong>$1</strong><span>files</span> across the project.",
    "files": "files",
    "edits": "edits",
    "no-contributions-this-year": "You didn't edit this project this year, but... <strong>$1</strong> is another year to contribute to the sum of all human knowledge!",
    "no-contributions": "You didn't edit this project this year, but...",
    "next-year": "is another year to contribute to the sum of all human knowledge!",
    "day-0": "Sundays",
    "day-1": "Mondays",
    "day-2": "Tuesdays",
    "day-3": "Wednesdays",
    "day-4": "Thursdays",
    "day-5": "Fridays",
    "day-6": "Saturdays",
    "time-afternoon": "afternoon editor",
    "time-morning": "morning editor",
    "time-lunch": "lunchtime editor",
    "time-sleep": "before bedtime editor",
    "time-night": "nocturnal editor",
    "time-early": "early editor",
    "time-evening": "evening editor",
    "thanks-for-caring": "Thank you caring!",
    "we-appreciate-you": "We appreciate you!",
    "thank-fan": "was your biggest fan",
	"thanked-most": "was the user you thanked the most",
    "share-text": "Here is how I have been contributing to Wikipedia in $1! Edits: $2, Discussions: $3, Thanks: $4, Thanked: $5 #wikipediaYIR",
    "generate-your-own": "Generate your own Year in Review at",
    "interface-edits": "interface edits",
    "template-edits": "template edits",
    "talk-page-edits": "talk page edits",
    "thanked": "thanked",
    "file-uploads": "file uploads",
    "claims": "claims",
    "badge-chatterbox": "chatterbox",
    "badge-chatterbox-desc": "You edited talk pages more than 1000 times.",
    "badge-100": "100 club",
    "badge-100-desc": "You edited more than 100 times",
    "badge-1k": "1K Club",
    "badge-1k-desc": "You edited more than 1000 times",
    "badge-10k": "10K Club",
    "badge-10k-desc": "You edited more than 10,000 times",
    "badge-100k": "100K Club",
    "badge-100k-desc": "You edited more than 100,000 times",
    "badge-1m": "millionaires club",
    "badge-1m-desc": "You edited more than a million times. Is that even possible!?",
    "badge-appreciated": "appreciated",
    "badge-appreciated-desc": "You were appreciated a significant amount of times. You are a pillar to your community!",
    "badge-proofreader": "proofreader",
    "badge-proofreader-desc": "You proofread over 50 pages! Impressive!",
    "badge-template-wizard": "template wizard",
    "badge-template-wizard-desc": "You edited more than 50 pages in the Module and Template namespace",
    "badge-interface-hero": "interface hero",
    "badge-interface-hero-desc": "You edited more than 20 pages in the MediaWiki namespace",
    "badge-day-desc": "The day you were most likely to edit",
    "badge-archivist": "archivist",
    "badge-archivist-desc": "You uploaded more files than there were days in the year",
    "badge-timeslot-desc": "The time you were most likely to edit was $1",
    "longest-streak": "longest streak",
    "badge-streak": "marathoner",
    "badge-streak-desc": "A badge for editors who edited for more than 50 consecutive days.",
    "language-he": "Hebrew",
    "language-id": "Indonesian",
    "language-pl": "Polish",
    "language-sv": "Swedish",
    "language-uk": "Ukrainian",
    "language-zh-hant": "Chinese (Traditional)",	
    "language-ko": "Korean",
    "language-nb": "Norwegian Bokmål",
    "language-zh-hans": "Simplified Chinese",
    "you-made-edits-across-project": "You made <strong>$1</strong> <span>edits</span> across the project",
    "streak-message": "At one point this year you edited the project<strong>$1</strong>consecutive days!",
    "paragraph-message": "Editing approximately <strong>$1</strong> <span>paragraphs</span>of text!",
    "you-made-edits-num-articles": "You made <strong>$1</strong> edits in $2 different articles",
    "edited-most-day-total": "You edited the most on <strong>$1</strong> ($2 edits)",
    "most-edited-time-sleep": "Most editing occurs between <strong>$1</strong> $2",
    "talk-message": "You contributed <strong>$1</strong> <span>times</span> to discussions.",
    "template-message": "You edited templates <strong>$1</strong> <span>times</span>",
    "gadget-message": "You edited gadgets and interface messages <strong>$1</strong> <span>times</span>",
    "appreciated-message": "You were appreciated by <strong>$1</strong> <span>editors</span>",
    "appreciated-message-1a": "And you showed appreciation to <strong>$1</strong> <span>other humans</span>",
    "appreciated-message-1b": "You showed appreciation to <strong>$1</strong> <span>other humans</span>"
}

